import "./SendDocs.css";
import SendNewDocModal from "../../Components/Modal/SendNewDocModal";

export default function SendNewDocButton() {
    return (
        <SendNewDocModal modifyDoc={false}></SendNewDocModal>
    )
}